import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { Request } from '@/api/batch-reservations/get-requests'

export const mockGetRequests = http.get(
  '/my-batches/api/batch/v1/booking-requests',
  ({ request }) => {
    const url = new URL(request.url)

    const status = url.searchParams.get('status')

    if (status === 'INVALID') {
      return HttpResponse.json({ message: 'Invalid Status.' })
    }

    const requests: Request[] = Array.from({ length: 100 }).map(() => {
      return {
        batchId: faker.number.int({ min: 10000, max: 99999 }),
        requestAlphaId: faker.string.uuid(),
        status: 'PENDING',
        bookingId: faker.number.int({ min: 10000, max: 99999 }).toString(),
        checkIn: faker.date.recent().toISOString(),
        checkOut: faker.date.recent().toISOString(),
        guest: faker.person.fullName(),
        hotel: faker.company.name(),
        travel: faker.number.int({ min: 10000, max: 99999 }).toString(),
      }
    })

    return HttpResponse.json({ data: requests })
  },
)
